import { render, staticRenderFns } from "./EmailVerificationDialog.vue?vue&type=template&id=474dfa54&scoped=true&"
import script from "./EmailVerificationDialog.vue?vue&type=script&lang=js&"
export * from "./EmailVerificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerificationDialog.vue?vue&type=style&index=0&id=474dfa54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474dfa54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VForm,VOtpInput,VRow})
